export default function customEmailValidator() {
    // See enforce-email-tld.spec.js for what's (dis)allowed.
    let EMAIL_REGEXP = /^[\-\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF~!\$%\^&\*=\+}{'?]+(\.[\-\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF~!\$%\^&\*=\+}{'?]+)*@([a-z0-9][-a-z0-9]*(\.[-a-z0-9]+)*\.([a-z][a-z]+)|([\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}))(:[\d]{1,5})?$/i;
    return {
        restrict: 'E',
        require: '?ngModel',
        link: (scope, elem, attrs, ctrl) => {
            if (ctrl && ctrl.$validators.email) {
                ctrl.$validators.email = (value) => {
                    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
                };
            }
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/custom-email-validator.js